import axios from '../axios'

/*
 * 刷新缓存模块
 */

// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/cache/list',
        method: 'post',
        data
    })
}
// 刷新
export const refresh = (params) => {
    return axios({
        url: '/cache/refresh',
        method: 'post',
        params:params
    })
}



// WEBPACK FOOTER //
// ./src/http/modules/cache.js